import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "./OtherProducts.css";
import { FiArrowUpRight } from "react-icons/fi";
import { resolveMediaUrl } from "../../../../utils/media";

// IMPORT YOUR IMAGES
import img1 from "../../../../assets/images/home/otherProducts/c1.jpg";
import img2 from "../../../../assets/images/home/otherProducts/c2.png";
import img3 from "../../../../assets/images/home/otherProducts/c3.png";

const fallbackOtherProducts = {
  titleLine1: "Other",
  titleLine2: "products",
  openProductText: "Open product",
  item1Title: "DRYWALL METAL PROFILE",
  item1Description:
    "The structural foundation for reliable, precision-built partition systems.",
  item1Image: img1,
  item1Link: "/products/drywall-metal-frame",
  item2Title: "CEILING METAL PROFILE",
  item2Description:
    "Flexible framing solutions engineered for flawless suspended and fixed ceiling installations.",
  item2Image: img2,
  item2Link: "/products/ceiling-metal-frame",
  item3Title: "ACCESSORIES",
  item3Description:
    "Everything you need to complete your drywall and ceiling systems.",
  item3Image: img3,
  item3Link: "/accessories",
};

const itemFieldRegex = /^item(\d+)([a-zA-Z0-9_]+)$/i;
const FIXED_CARD_LINKS = {
  1: "/products/drywall-metal-frame",
  2: "/products/ceiling-metal-frame",
  3: "/accessories",
};

const hasSectionData = (section) => {
  if (!section || typeof section !== "object") return false;
  return Object.values(section).some((value) => {
    if (value === null || typeof value === "undefined") return false;
    if (typeof value === "string") return value.trim().length > 0;
    return true;
  });
};

const getItemImageFromApi = (content, itemNumber) => {
  const suffix = String(itemNumber);
  const candidates = [
    content?.[`item${suffix}Image`],
    content?.[`item${suffix}image`],
    content?.[`item${suffix}Img`],
    content?.[`item${suffix}img`],
    content?.[`item${suffix}Icon`],
    content?.[`item${suffix}icon`],
    content?.[`item${suffix}Media`],
    content?.[`item${suffix}media`],
    content?.[`item${suffix}MediaUrl`],
    content?.[`item${suffix}mediaUrl`],
    content?.[`item${suffix}Photo`],
    content?.[`item${suffix}photo`],
  ];

  for (const candidate of candidates) {
    const resolved = resolveMediaUrl(candidate);
    if (resolved) return resolved;
  }
  return "";
};

const OtherProducts = ({ content }) => {
  const hasApiContent = hasSectionData(content);
  const otherProductsContent = hasApiContent ? content : fallbackOtherProducts;
  const products = useMemo(() => {
    const cardsMap = new Map();
    Object.entries(otherProductsContent || {}).forEach(([key, value]) => {
      const match = key.match(itemFieldRegex);
      if (!match) return;
      const index = Number(match[1]);
      const field = String(match[2] || "").replace(/[_\s-]+/g, "").toLowerCase();
      if (!cardsMap.has(index)) cardsMap.set(index, {});
      cardsMap.get(index)[field] = value;
    });

    const mapped = Array.from(cardsMap.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([index, fields], idx) => ({
        title: fields.title || "",
        description: fields.description || "",
        image: hasApiContent
          ? getItemImageFromApi(otherProductsContent, index) ||
            resolveMediaUrl(fields.image || fields.img || fields.icon || fields.media || fields.mediaurl) ||
            ""
          : fields.image || fields.img || fields.icon || fields.media || fields.mediaurl || "",
        to: FIXED_CARD_LINKS[index] || fields.link || "/products",
      }))
      .filter((item) => item.title || item.description || item.to || item.image);

    if (mapped.length) return mapped;
    return [
      {
        title: fallbackOtherProducts.item1Title,
        description: fallbackOtherProducts.item1Description,
        image: fallbackOtherProducts.item1Image,
        to: fallbackOtherProducts.item1Link,
      },
      {
        title: fallbackOtherProducts.item2Title,
        description: fallbackOtherProducts.item2Description,
        image: fallbackOtherProducts.item2Image,
        to: fallbackOtherProducts.item2Link,
      },
      {
        title: fallbackOtherProducts.item3Title,
        description: fallbackOtherProducts.item3Description,
        image: fallbackOtherProducts.item3Image,
        to: fallbackOtherProducts.item3Link,
      },
    ];
  }, [otherProductsContent, hasApiContent]);

  return (
    <section className="other-products">
      <div className="other-products-container">
        <h2 className="other-title">
          {otherProductsContent.titleLine1 || "Other"} <span>{otherProductsContent.titleLine2 || "products"}</span>
        </h2>

        <div className="other-grid">
          {products.map((item, index) => (
            <Link className="other-card" key={index} to={item.to || "/products"}>
              <div className="other-image">
                <img src={item.image} alt={item.title} />
              </div>

              <div className="other-content">
                <h3>{item.title}</h3>

                <p>{item.description}</p>

                <div className="other-link">
                  {otherProductsContent.openProductText || "Open product"} <FiArrowUpRight />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OtherProducts;